import { styled, InputLabel as BaseInputLabel, Theme } from '@material-ui/core'
import { Icon as BaseIcon } from '@iconify/react'
import { KeyboardDatePicker as BaseKeyboardDatePicker } from '@material-ui/pickers'

const DATE_PICKER_HEIGHT = 32
const HELPER_TEXT_HEIGHT = 0
const HELPER_TEXT_BOTTOM = 0
const HELPER_TEXT_LEFT = -10

export const KeyboardDatePicker = styled(BaseKeyboardDatePicker)(
  ({ theme }) => ({
    '& fieldset': {
      top: 0,
    },
    '& .MuiInputBase-root': {
      height: DATE_PICKER_HEIGHT,
      '& .MuiInputAdornment-root': {
        '& button': {
          padding: theme.spacing(0.3),
        },
      },
    },
    '& .MuiFormHelperText-contained': {
      position: 'absolute',
      bottom: HELPER_TEXT_BOTTOM,
      left: HELPER_TEXT_LEFT,
      height: HELPER_TEXT_HEIGHT,
      whiteSpace: 'nowrap',
    },
  })
)

export const InputLabel = styled(BaseInputLabel)(({ theme }) => ({
  marginBottom: theme.spacing(),
  whiteSpace: 'nowrap',
}))

export const Icon = styled(BaseIcon)(
  ({
    theme,
    disabled,
    isError,
  }: {
    theme: Theme
    disabled?: boolean
    isError: boolean
  }) => ({
    color: disabled
      ? theme.palette.text.disabled
      : isError
      ? theme.palette.error.main
      : theme.palette.primary.main,
    transition: 'all .3s',
  })
)
